import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { CustomDOMEvents } from '@/enums/customDOMEvents'
import { PageName } from '@/enums/pageName'
import { CheckoutFlowVersion } from '@/enums/payments'
import { getPath } from '@/utils/urlUtils'

import { useAuth } from '@/auth/useAuth'

import { ISessionContext } from '../session'

function getPageNameToRedirectAfterLogout(checkoutFlowVersion: CheckoutFlowVersion): PageName {
  if (checkoutFlowVersion === CheckoutFlowVersion.V2) {
    return PageName.selectPlan
  } else {
    return PageName.registration
  }
}

export function useLogoutHandler(sessionContext: ISessionContext) {
  const navigate = useNavigate()
  const { logout } = useAuth()

  const onLogoutHandler = useCallback(() => {
    logout()
    navigate(getPath(getPageNameToRedirectAfterLogout(sessionContext.checkoutFlowVersion)))
  }, [navigate, logout, sessionContext])

  useEffect(() => {
    document.addEventListener(CustomDOMEvents.ON_401, onLogoutHandler)

    return () => {
      document.removeEventListener(CustomDOMEvents.ON_401, onLogoutHandler)
    }
  }, [onLogoutHandler])
}
